import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  LicenseTypes,
  MasterPages,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import Add from "./Add";
import List from "./List";
import { IObjectKeys } from "../../../../../utils/formTypes";
import { Form, Formik, FormikProps } from "formik";
import {
  categoryValidation,
  mouValidation,
} from "../../../../../utils/validationSchema";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { nodeVar, OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  AddStockMoUResult,
  AddStockMoUVar,
  AtsStckUoM,
  AtsStckUoMOrderField,
  UpdateStockMoUResult,
  UpdateStockMoUVar,
} from "./queries/types";
import { AddStockUoM, UpdateStockUoM } from "./queries/mutations";
import { GetStockUoM, GetStockUoMByNodeId } from "./queries/queries";
import { removeMoreSpace } from "../../../../../utils/UtilFunctions";
import { MasterDataProps } from "../itemgroup/Index";
import Close from "../../../../../images/Close.svg";
import LoadingModal from "../../../../pages/LoadingModal";
import { payloadTypes } from "../../../../../context/reducer";
import Navbar from "../../../../common/layout/Navbar";
interface formDataType extends IObjectKeys {
  uom: string;
  uomDesc: string;
  useDecimals: boolean;
  decimalNos: string;
}

export interface ListProps extends MasterDataProps {
  operation: Operation;
  setOperation: React.Dispatch<React.SetStateAction<Operation>>;
}
export interface AddMasterDataProps extends ListProps {
  formData: formDataType;
  handleValueChange: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => void;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
  meta: FormikProps<formDataType>;
}

const UOM = ({ type, setModal }: MasterDataProps) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(emptyMessage);
  

  const { user_details } = useLoggedInUserDetails();

  const { state, dispatch } = useContext(AppContext);

  const [operation, setOperation] = useState(Operation.CREATE);
  const { customer_id } = useUrlParams();
  const initialValues: formDataType = {
    decimalNos: "",
    uom: "",
    uomDesc: "",
    useDecimals: false,
  };
  const [formData, setFormData] = useState<formDataType>(initialValues);

  const [GetUom, { loading: GetStockUoMByNodeIdLoading }] = useLazyQuery<
    { node: AtsStckUoM },
    nodeVar
  >(GetStockUoMByNodeId);

  const [AddStockUom, { loading: AddStockUoMLoading }] = useMutation<
    AddStockMoUResult,
    AddStockMoUVar
  >(AddStockUoM, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [UpdateUoM, { loading: UpdateStockUoMLoading }] = useMutation<
    UpdateStockMoUResult,
    UpdateStockMoUVar
  >(UpdateStockUoM, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleClear = () => {
    setFormData(initialValues);
  };

  const handleSubmit = async () => {
    if (customer_id) {
      if (operation === Operation.CREATE) {
        const empAdded = AddStockUom({
          variables: {
            
            user_details,
            customer_id,
            input: {
              decimalNos: Number(formData.decimalNos),
              uom: removeMoreSpace(formData.uom),
              uomDesc: removeMoreSpace(formData.uomDesc),
              useDecimals: formData.useDecimals,
            },
          },
          refetchQueries: [
            {
              query: GetStockUoM,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckUoMOrderField.UOM,
                },
                
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await empAdded;
        if (data && data.AddStockUoM) {
          setMessage({
            flag: true,
            message: "UOM added successfully",
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateUoM({
          variables: {
            
            user_details,
            uom_id: state.uomId,
            input: {
              decimalNos: Number(formData.decimalNos),
              uom: formData.uom,
              uomDesc: removeMoreSpace(formData.uomDesc),
              useDecimals: formData.useDecimals,
            },
          },
          refetchQueries: [
            {
              query: GetStockUoM,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckUoMOrderField.UOM,
                },
                
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await customerUpdated;
        if (data && data.UpdateStockUoM) {
          setMessage({
            flag: true,
            message: "UOM details updated successfully",
            operation: Operation.CREATE,
          });
          dispatch({
            type: payloadTypes.SET_UOM_ID,
            payload: {
              uomId: 0,
            },
          });
        }
      }
    }
  };

  const hanldeClear = () => {
    setFormData(initialValues);
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      hanldeClear();
    }
    setMessage(emptyMessage);
    setOperation(Operation.CREATE)
  };

  useEffect(() => {
    const fetchData = async () => {
      if (state.uomId && operation === Operation.UPDATE) {
        GetUom({
          variables: {
            id: state.uomId,
            
          },
        }).then(({ data }) => {
          if (data && data.node) {
            setFormData({
              decimalNos: data.node.decimalNos.toString(),
              uom: data.node.uom,
              uomDesc: data.node.uomDesc,
              useDecimals: data.node.useDecimals,
            });
          }
        });
      }
    };
    fetchData();
  }, [state.uomId, GetUom, operation]);

  return (
    <>
      {type === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      )}
      <div className="master-data--modal--title">
        <Title>UOM</Title>
        {type === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModal?.(false)} />
        )}
      </div>

      <Formik
        initialValues={formData}
        validationSchema={mouValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form
              className={`master-data${
                type === PageFor.MODAL ? "--modal" : ""
              }`}
            >
              <div
                className={`master-data__datablock${
                  type === PageFor.MODAL ? "--modal" : ""
                }`}
              >
                <div className="master-data__datablock--left">
                  <Add
                    type={PageFor.GENERAL}
                    formData={formData}
                    handleValueChange={handleValueChange}
                    setOperation={setOperation}
                    setFormData={setFormData}
                    meta={meta}
                    operation={operation}
                  />
                </div>
                <div className="master-data__datablock--right">
                  <List
                    type={PageFor.GENERAL}
                    setOperation={setOperation}
                    operation={operation}
                  />
                </div>
              </div>
              <Button mode="save" type="submit" />
              <Button mode="clear" type="button" onClick={handleClear} />
              {type === PageFor.GENERAL ? (
                <Button
                  mode="back"
                  type="button"
                  onClick={() => navigate(-1)}
                />
              ) : (
                <Button
                  mode="cancel"
                  type="button"
                  onClick={() => setModal?.(false)}
                />
              )}
            </Form>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetStockUoMByNodeIdLoading ||
          AddStockUoMLoading ||
          UpdateStockUoMLoading
        }
      />
    </>
  );
};

export default UOM;
